import("@ui/microApp/ApplicationBootstrap");
